module.exports = __webpack_public_path__ + "static/media/Aditya_Deshmukh.66a1b548.png";